import { render, staticRenderFns } from "./GoogleReview.vue?vue&type=template&id=13b61b48"
import script from "./GoogleReview.vue?vue&type=script&lang=js"
export * from "./GoogleReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports